import { render, staticRenderFns } from "./MailButton.vue?vue&type=template&id=57f17693&scoped=true&"
import script from "./MailButton.vue?vue&type=script&lang=ts&"
export * from "./MailButton.vue?vue&type=script&lang=ts&"
import style0 from "./MailButton.vue?vue&type=style&index=0&id=57f17693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f17693",
  null
  
)

export default component.exports